import React from 'react';
import styles from './styles.scss';

import { AUTHOR_MAP } from './authorMap';

const AuthorCallout = (props) => {
  const { slug } = props;
  const course = slug.split('-')[0];
  const { description, imageSrc } = AUTHOR_MAP[course];

  return (
    <div className={styles.layout}>
      <img className={styles.image} src={imageSrc} />
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default AuthorCallout;
